import { z } from "zod";

export const env = z
  .object({
    NODE_ENV: z.enum(["development", "production", "test"]).optional(),
    BUGSNAG_API_KEY: z.string().optional(),
    DEV_ENV: z
      .string()
      .default("true")
      .transform((value) => value === "true"),
    NEXT_PHASE: z.string().optional(),
    BASE_URL: z.url().default("http://localhost:3001"),
  })
  .parse({
    NODE_ENV: process.env.NEXT_PUBLIC_NODE_ENV ?? process.env.NODE_ENV,
    BUGSNAG_API_KEY: process.env.NEXT_PUBLIC_BUGSNAG_API_KEY,
    DEV_ENV: process.env.NEXT_PUBLIC_DEV_ENV,
    NEXT_PHASE: process.env.NEXT_PHASE,
    BASE_URL: process.env.NEXT_PUBLIC_BASE_URL,
  });

export const isBuildPhase = () => {
  return env.NEXT_PHASE === "phase-production-build";
};
